import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import { responseObj } from '../nest-model/nest-model';

@Injectable()
export class ElearningProvider {

  private _service: string = 'elearning';
  private _model: string = 'sf6s/elearning';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public updateStartTime(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'updateStartTime';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public submitQuiz(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'submitQuiz';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public updatePost(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'updatePost';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public submitRequest(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'add';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public addVideoContent(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'addVideoContent';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public submitJoin(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'submitJoin';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public submitReply(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'addReply';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public markAsCompleted(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'markAsCompleted';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public submitDiscussion(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'addDiscussion';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public resubmitRequest(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'save';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public deleteDraft(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'delete';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public searchClass(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'searchClass';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public uploadSetting(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'uploadSetting';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';
    const timeout: number = (5 * 60) * 1000;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType, timeout);
  }

  public treeEbook(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'treeEbook';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public discussionDetail(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'discussionDetail';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public discussion(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'discussion';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public quote(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'quote';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public score(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'score';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public quiz(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'quiz';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public saveTo(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'saveTo';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public searchEmployee(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'searchEmployee';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public catalogue(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'catalogue';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public request(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'request';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public class(): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'class';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public myClass(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'myClass';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public listingCatalog(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'listingCatalog';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public listingClass(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'listingClass';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public listingReq(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'listingReq';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public reStartQuiz(formData): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'reStartQuiz';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public getFeedBackSetting(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'feedBackSetting';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public getRequest(requestNo): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'getRequest';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    if (typeof requestNo !== 'undefined' && requestNo !== null) _urlParams.requestNo = requestNo;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public getEvaluationSetting(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'evaluationSetting';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public evaluation(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'evaluation';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';
   
    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }
    
  public evaluationStage(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'evaluationStage';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  saveEvaluation(formData) {
    const _method: string = 'POST';
    const _func: string = 'saveEvaluation';
    const _params: any = formData || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request<responseObj<any>>(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public listingEvaluation(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'listingEvaluation';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public memberEvaluation(formData): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'memberEvaluation';
    const _params: any = {};
    const _urlParams: any = formData;
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/elearning/elearning.ts